import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  Skeleton,
  Table,
  Tr,
  Th,
  Td,
  Text
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { VideoQuizComplete } from '../../../services/VideoQuiz/types'
import { VideoQuizService } from '../../../services/VideoQuiz/VideoQuiz.service'

interface IProps {
  isOpen: boolean
  onClose: () => void
  id?: number
}

export function VideoQuizViewModal({ isOpen, onClose, id }: IProps) {
  const service = new VideoQuizService()
  const [loading, setLoading] = useState(true)
  const [videoQuiz, setVideoQuiz] = useState<VideoQuizComplete>({} as any)

  useEffect(() => {
    if (!id) return

    setLoading(true)
    service.get(id).then((response) => {
      setVideoQuiz(response)
      setLoading(false)
    })
  }, [id])

  const calcPercentage = (value1: number, value2: number): string => {
    if (value1 === 0 && value2 === 0) return '0.00'

    return ((value1 / (value1 + value2)) * 100).toFixed(2)
  }

  return (
    <>
      <ChakraModal isOpen={isOpen} onClose={onClose} size="3xl" isCentered scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Skeleton isLoaded={!loading} width="50%">
              {videoQuiz.name || '-'}
            </Skeleton>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={5}>
            <Table>
              <Tr>
                <Th>Nome do Aluno:</Th>
                <Td>
                  <Skeleton isLoaded={!loading}>{videoQuiz.name || '-'}</Skeleton>
                </Td>
              </Tr>
              <Tr>
                <Th>E-mail:</Th>
                <Td>
                  <Skeleton isLoaded={!loading}>{videoQuiz.email || '-'}</Skeleton>
                </Td>
              </Tr>
              <Tr>
                <Th>Telefone:</Th>
                <Td>
                  <Skeleton isLoaded={!loading}>{videoQuiz.phone || '-'}</Skeleton>
                </Td>
              </Tr>
              <Tr>
                <Th>Vídeo Atual:</Th>
                <Td>
                  <Skeleton isLoaded={!loading}>{videoQuiz.current_step || '-'}</Skeleton>
                </Td>
              </Tr>
              <Tr>
                <Th>Acertos:</Th>
                <Td>
                  <Skeleton isLoaded={!loading}>
                    {videoQuiz.correct_answers_count}{' '}
                    <small>
                      ({calcPercentage(videoQuiz.correct_answers_count, videoQuiz.incorrect_answers_count)}%)
                    </small>
                  </Skeleton>
                </Td>
              </Tr>
              <Tr>
                <Th>Erros:</Th>
                <Td>
                  <Skeleton isLoaded={!loading}>
                    {videoQuiz.incorrect_answers_count}{' '}
                    <small>
                      ({calcPercentage(videoQuiz.incorrect_answers_count, videoQuiz.correct_answers_count)}%)
                    </small>
                  </Skeleton>
                </Td>
              </Tr>
              <Tr>
                <Th>Iniciado em:</Th>
                <Td>
                  <Skeleton isLoaded={!loading}>
                    {new Date(videoQuiz.created_at).toLocaleString('pt-BR').replace(',', ' -').slice(0, -3)}
                  </Skeleton>
                </Td>
              </Tr>
            </Table>

            <Text my={4} fontWeight="bold">
              Respostas enviadas
            </Text>

            {loading &&
              Array.from({ length: 6 }).map((_, index) => (
                <div className="shadow-sm p-3 my-4 rounded" key={index}>
                  <Skeleton width="100%" height="20px" mb={2} />
                  {Array.from({ length: 4 }).map((_, index) => (
                    <Skeleton
                      key={index}
                      width={`${Math.floor(Math.random() * (100 - 40 + 1) + 40)}%`}
                      height="20px"
                      mb={1}
                    />
                  ))}
                  <Skeleton width="40%" height="20px" mb={1} mt={2} ms="auto" />
                </div>
              ))}

            {!loading &&
              videoQuiz.questions.map((question, index) => (
                <div key={index} className="shadow-sm p-3 my-4 rounded">
                  <Text mb={2}>{question.question}</Text>
                  {question.answers.map((answer, index) => (
                    <Text key={index} color={answer.correct ? 'green.500' : answer.user_answer ? 'red.500' : 'black'}>
                      <strong>{String.fromCharCode(65 + index)}</strong> - {answer.answer}
                    </Text>
                  ))}
                  <Text mt={2} fontSize="xs" textAlign="right">
                    Resposta realizada em: {new Date(question.created_at).toLocaleString('pt-BR').replace(',', ' -')}
                  </Text>
                </div>
              ))}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onClose} type="button">
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  )
}
